import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Compass, Check } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// After booking: one-tap, opt-in sharing of the member's latest GAUGE reflection with their enhancer(s).
export default function ShareReflectionPrompt({ enhancerId = "" }) {
  const { user } = useAuth();
  const { data, refetch } = useQuery({ queryKey: ["gauge-latest-share"], queryFn: () => api.get("/me/gauge/latest-share").then((r) => r.data), enabled: !!user });
  const [busy, setBusy] = useState("");
  const ex = data?.exploration;
  if (!user || !ex) return null;
  const opts = (data.options || []).filter((o) => !enhancerId || o.id === enhancerId);
  if (!opts.length) return null;
  const share = async (id) => {
    setBusy(id);
    try { await api.put(`/me/gauge/explorations/${ex.id}/share`, { enhancer_ids: [...new Set([...(ex.shared_with || []), id])] }); toast.success("Shared — you can stop sharing anytime from My Journey"); refetch(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  return (
    <div className="mt-5 text-left rounded-2xl border border-[#E5E0D8] bg-white p-4" data-testid="share-reflection-prompt">
      <p className="text-sm font-semibold text-[#1A242B] flex items-center gap-2"><Compass size={15} className="text-[#D98E73]" /> Help your enhancer prepare?</p>
      <p className="text-xs text-[#4A5D6B] mt-1">Optionally share your latest GAUGE reflection ({ex.path_title}). It stays private unless you choose, and you can stop sharing anytime.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        {opts.map((o) => {
          const on = (ex.shared_with || []).includes(o.id);
          return (
            <button key={o.id} onClick={() => !on && share(o.id)} disabled={on || busy === o.id} data-testid={`share-reflection-${o.id}`}
              className={`text-sm rounded-full px-3 py-1.5 border inline-flex items-center gap-1.5 ${on ? "border-[#5C8A72] text-[#5C8A72]" : "border-[#144F75] text-[#144F75] hover:bg-[#144F75]/[0.06]"}`}>
              {on ? <><Check size={14} /> Shared with {o.name}</> : `Share with ${o.name}`}
            </button>
          );
        })}
      </div>
    </div>
  );
}
